import { TZDate } from "@date-fns/tz";

/** Default wall-clock prime time when the CMS value is missing or malformed. */
const DEFAULT_PRIME_TIME = "20:00";

/** Prepr passes prime time through raw, so accept `9:30`, `20:00` and `20:00:00`. */
const WALL_CLOCK = /^(\d{1,2}):([0-5]\d)(?::[0-5]\d)?$/;

const parseWallClock = (
  primeTime: string,
): { hour: number; minute: number } => {
  const match = WALL_CLOCK.exec(primeTime.trim());
  if (!match) {
    return { hour: 20, minute: 0 };
  }
  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (hour > 23) {
    return { hour: 20, minute: 0 };
  }
  return { hour, minute };
};

/** Wall-clock instant on the same calendar day as `dayStart`. */
const getPrimeTimeInstantMs = (
  dayStart: Date,
  primeTime: string = DEFAULT_PRIME_TIME,
  timeZone?: string,
): number => {
  const { hour, minute } = parseWallClock(primeTime);

  if (timeZone) {
    const zoned = new TZDate(dayStart.getTime(), timeZone);
    zoned.setHours(hour, minute, 0, 0);
    return zoned.getTime();
  }

  const d = new Date(dayStart.getTime());
  d.setHours(hour, minute, 0, 0);
  return d.getTime();
};

export default getPrimeTimeInstantMs;
